import { Requester } from './Requester';
import { ILoanGroupRecord } from '../types';

export const PostOrganizationLoanGroup = async ({
    orgId,
    loanGroup
}: {
    orgId?: string;
    loanGroup: Record<string, any>;
}): Promise<ILoanGroupRecord | null> => {
    if (!orgId) return null;
    try {
        const response = await Requester<{ loanGroup: ILoanGroupRecord } | null>({
            path: `organizations/${orgId}/loanGroups`,
            method: 'POST',
            payload: loanGroup
        });

        if (response && 'loanGroup' in response && Object.hasOwn(response.loanGroup, '_id')) return response.loanGroup;
        return null;
    } catch (e) {
        console.error('Create organization loan group request failed');
        return Promise.reject(e);
    }
};
